import { ShareholderIntervalPricing } from "./electronicGeneralMeetingDomain";
import { useTranslation } from "@/stores/RootStoreContext";
import { Dialog } from "@/components-v2/Dialog";
import { Box, VBox } from "@/components-v2/Box";
import { Markdown } from "@/text/Markdown";
import { Icon } from "@/components-v2/Icon";
import { observer } from "mobx-react";
import LiveGF from "@/assets/img/Live-GF.gif";
import { isMobileView } from "@/utils/screen";
import { TMessage } from "@/i18n/tt";

export const LiveGeneralMeetingAnnouncementDialog = observer(
  function LiveGeneralMeetingAnnouncementDialog({
    onClose,
    closeLabel,
    onSubmit,
    submitLabel,
    shareholderPricingInterval,
  }: {
    onClose: () => void;
    onSubmit?: () => void;
    closeLabel?: TMessage;
    submitLabel?: TMessage;
    shareholderPricingInterval?: ShareholderIntervalPricing;
  }) {
    const { t } = useTranslation();
    return (
      <Dialog
        fullscreen={isMobileView()}
        cancelLabel={closeLabel ?? t("close")}
        onCancel={onClose}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
      >
        <VBox textAlign={"center"} justifyContent={"center"} alignItems={"center"} gap={"lg"}>
          <img src={LiveGF} alt={"LiveGF"} />
          <h3>
            <Markdown value={t("release-announcement.general-meeting-title")} enableLinks />
          </h3>
          <Markdown value={t("release-announcement.general-meeting-description")} enableLinks />
          <Markdown
            value={t("release-announcement.general-meeting.price-per-meeting", {
              s: shareholderPricingInterval?.label ?? "",
              p:
                shareholderPricingInterval && shareholderPricingInterval.from === 100
                  ? shareholderPricingInterval.price
                  : `NOK ${shareholderPricingInterval?.price}`,
            })}
            enableLinks
          />
          <div>
            <strong>{t("release-announcement.general-meeting.to-help")}</strong>
            <Markdown value={t("release-announcement.general-meeting.contact-us")} enableLinks />
          </div>
          <Box vertical={isMobileView()}>
            <Box alignItems={"center"}>
              <Markdown
                value={t("release-announcement.general-meeting.product-sheet")}
                enableLinks
                disableLastMargin
              />{" "}
              <Icon name="download" color={"info"} />
            </Box>
            <Box alignItems={"center"}>
              <Markdown
                value={t("release-announcement.general-meeting.participant-guide")}
                enableLinks
                disableLastMargin
              />{" "}
              <Icon name="download" color={"info"} />
            </Box>
          </Box>
        </VBox>
      </Dialog>
    );
  },
);
